// projectCostPriority component actionTypes

export const ADD_FAVOURITE_PROJECT_COST_PRIORITY = 'add_favourite_project_cost_priority';
export const ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS = 'add_favourite_project_cost_priority_success';
export const FETCH_PROJECT_COST_PRIORITY = 'fetch_project_cost_priority';
export const FETCH_PROJECT_COST_PRIORITY_SUCCESS = 'fetch_project_cost_priority_success';
export const FETCH_ALL_PROJECT_COST_PRIORITY = 'fetch_all_project_cost_priority';
export const FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS = 'fetch_all_project_cost_priority_success';
export const FILTER_PROJECT_COST_PRIORITY = 'filter_project_cost_priority';
export const GET_ALL_PROJECT_COST_PRIORITY = 'get_all_project_cost_priority';
export const GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY = 'get_unselected_all_project_cost_priority';
export const HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE = 'handle_project_cost_priority_request_close';
export const HIDE_PROJECT_COST_PRIORITY_LOADER = 'hide_project_cost_priority_loader';
export const SHOW_PROJECT_COST_PRIORITY_LOADER = 'show_project_cost_priority_loader';
export const ON_ADD_PROJECT_COST_PRIORITY = 'on_add_project_cost_priority';
export const ON_EDIT_PROJECT_COST_PRIORITY = 'on_edit_project_cost_priority';
export const ON_ALL_PROJECT_COST_PRIORITY_SELECT = 'on_all_project_cost_priority_select';
export const ON_PROJECT_COST_PRIORITY_CLOSE = 'on_project_cost_priority_close';
export const ON_PROJECT_COST_PRIORITY_SELECT = 'on_project_cost_priority_select';
export const ON_DELETE_PROJECT_COST_PRIORITY = 'on_delete_project_cost_priority';
export const ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS = 'on_delete_project_cost_priority_success';
export const ON_FILTER_SELECTED_PROJECT_COST_PRIORITY = 'on_filter_selected_project_cost_priority';
export const ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT = 'on_filter_project_cost_priority_option_select';
export const ON_SAVE_PROJECT_COST_PRIORITY = 'on_save_project_cost_priority';
export const ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS = 'on_save_project_cost_priority_success';
export const ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER = 'on_toggle_project_cost_priority_drawer';
export const SHOW_PROJECT_COST_PRIORITY_MESSAGE = 'show_project_cost_priority_message';
export const UPDATE_SEARCH_PROJECT_COST_PRIORITY = 'update_search_project_cost_priority';

// projectBusPriority component actionTypes

export const ADD_FAVOURITE_PROJECT_BUS_PRIORITY = 'add_favourite_project_bus_priority';
export const ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS = 'add_favourite_project_bus_priority_success';
export const FETCH_PROJECT_BUS_PRIORITY = 'fetch_project_bus_priority';
export const FETCH_PROJECT_BUS_PRIORITY_SUCCESS = 'fetch_project_bus_priority_success';
export const FETCH_ALL_PROJECT_BUS_PRIORITY = 'fetch_all_project_bus_priority';
export const FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS = 'fetch_all_project_bus_priority_success';
export const FILTER_PROJECT_BUS_PRIORITY = 'filter_project_bus_priority';
export const GET_ALL_PROJECT_BUS_PRIORITY = 'get_all_project_bus_priority';
export const GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY = 'get_unselected_all_project_bus_priority';
export const HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE = 'handle_project_bus_priority_request_close';
export const HIDE_PROJECT_BUS_PRIORITY_LOADER = 'hide_project_bus_priority_loader';
export const SHOW_PROJECT_BUS_PRIORITY_LOADER = 'show_project_bus_priority_loader';
export const ON_ADD_PROJECT_BUS_PRIORITY = 'on_add_project_bus_priority';
export const ON_EDIT_PROJECT_BUS_PRIORITY = 'on_edit_project_bus_priority';
export const ON_ALL_PROJECT_BUS_PRIORITY_SELECT = 'on_all_project_bus_priority_select';
export const ON_PROJECT_BUS_PRIORITY_CLOSE = 'on_project_bus_priority_close';
export const ON_PROJECT_BUS_PRIORITY_SELECT = 'on_project_bus_priority_select';
export const ON_DELETE_PROJECT_BUS_PRIORITY = 'on_delete_project_bus_priority';
export const ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS = 'on_delete_project_bus_priority_success';
export const ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY = 'on_filter_selected_project_bus_priority';
export const ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT = 'on_filter_project_bus_priority_option_select';
export const ON_SAVE_PROJECT_BUS_PRIORITY = 'on_save_project_bus_priority';
export const ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS = 'on_save_project_bus_priority_success';
export const ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER = 'on_toggle_project_bus_priority_drawer';
export const SHOW_PROJECT_BUS_PRIORITY_MESSAGE = 'show_project_bus_priority_message';
export const UPDATE_SEARCH_PROJECT_BUS_PRIORITY = 'update_search_project_bus_priority';

export const ADD_FAVOURITE_ISSUE = 'add_favourite_issue';
export const ADD_FAVOURITE_ISSUE_SUCCESS = 'add_favourite_issue_success';
export const FETCH_ISSUE = 'fetch_issue';
export const FETCH_ISSUE_SUCCESS = 'fetch_issue_success';
export const FETCH_ALL_ISSUE = 'fetch_all_issue';
export const FETCH_ALL_ISSUE_SUCCESS = 'fetch_all_issue_success';
export const FILTER_ISSUE = 'filter_issue';
export const GET_ALL_ISSUE = 'get_all_issue';
export const GET_UNSELECTED_ALL_ISSUE = 'get_unselected_all_issue';
export const HANDLE_ISSUE_REQUEST_CLOSE = 'handle_issue_request_close';
export const HIDE_ISSUE_LOADER = 'hide_issue_loader';
export const SHOW_ISSUE_LOADER = 'show_issue_loader';
export const ON_ADD_ISSUE = 'on_add_issue';
export const ON_EDIT_ISSUE = 'on_edit_issue';
export const SET_ISSUE = 'set_issue';
export const ON_ALL_ISSUE_SELECT = 'on_all_issue_select';
export const ON_ISSUE_CLOSE = 'on_issue_close';
export const ON_ISSUE_SELECT = 'on_issue_select';
export const ON_DELETE_ISSUE = 'on_delete_issue';
export const ON_DELETE_ISSUE_SUCCESS = 'on_delete_issue_success';
export const ON_FILTER_SELECTED_ISSUE = 'on_filter_selected_issue';
export const ON_FILTER_ISSUE_OPTION_SELECT = 'on_filter_issue_option_select';
export const ON_SAVE_ISSUE = 'on_save_issue';
export const ON_SAVE_ISSUE_SUCCESS = 'on_save_issue_success';
export const ON_TOGGLE_ISSUE_DRAWER = 'on_toggle_issue_drawer';
export const SHOW_ISSUE_MESSAGE = 'show_issue_message';
export const UPDATE_SEARCH_ISSUE = 'update_search_issue';
export const ON_FETCH_SELECT_FEATURE_DATA = 'on_fetch_select_feature_data';
export const ON_FETCH_SELECT_FEATURE_DATA_SUCCESS = 'on_fetch_select_feature_data_success';
export const ON_ISSUE_FEATURE_UPDATE = 'on_issue_feature_update';

// initiative component actionTypes

export const ADD_FAVOURITE_INITIATIVE = 'add_favourite_initiative';
export const ADD_FAVOURITE_INITIATIVE_SUCCESS = 'add_favourite_initiative_success';
export const FETCH_INITIATIVE = 'fetch_initiative';
export const FETCH_INITIATIVE_SUCCESS = 'fetch_initiative_success';
export const FETCH_ALL_INITIATIVE = 'fetch_all_initiative';
export const FETCH_ALL_INITIATIVE_SUCCESS = 'fetch_all_initiative_success';
export const FILTER_INITIATIVE = 'filter_initiative';
export const GET_ALL_INITIATIVE = 'get_all_initiative';
export const GET_UNSELECTED_ALL_INITIATIVE = 'get_unselected_all_initiative';
export const HANDLE_INITIATIVE_REQUEST_CLOSE = 'handle_initiative_request_close';
export const HIDE_INITIATIVE_LOADER = 'hide_initiative_loader';
export const SHOW_INITIATIVE_LOADER = 'show_initiative_loader';
export const ON_ADD_INITIATIVE = 'on_add_initiative';
export const ON_EDIT_INITIATIVE = 'on_edit_initiative';
export const SET_INITIATIVE = 'set_initiative';
export const ON_ALL_INITIATIVE_SELECT = 'on_all_initiative_select';
export const ON_INITIATIVE_CLOSE = 'on_initiative_close';
export const ON_INITIATIVE_SELECT = 'on_initiative_select';
export const ON_DELETE_INITIATIVE = 'on_delete_initiative';
export const ON_DELETE_INITIATIVE_SUCCESS = 'on_delete_initiative_success';
export const ON_FILTER_SELECTED_INITIATIVE = 'on_filter_selected_initiative';
export const ON_FILTER_INITIATIVE_OPTION_SELECT = 'on_filter_initiative_option_select';
export const ON_SAVE_INITIATIVE = 'on_save_initiative';
export const ON_SAVE_INITIATIVE_SUCCESS = 'on_save_initiative_success';
export const ON_TOGGLE_INITIATIVE_DRAWER = 'on_toggle_initiative_drawer';
export const SHOW_INITIATIVE_MESSAGE = 'show_initiative_message';
export const UPDATE_SEARCH_INITIATIVE = 'update_search_initiative';
export const ON_FETCH_SELECT_PRODUCT_DATA = 'on_fetch_select_product_data';
export const ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS = 'on_fetch_select_product_data_success';
export const ON_INITIATIVE_PRODUCT_UPDATE = 'on_initiative_product_update';

// product component actionTypes

export const ADD_FAVOURITE_PRODUCT = 'add_favourite_product';
export const ADD_FAVOURITE_PRODUCT_SUCCESS = 'add_favourite_product_success';
export const FETCH_PRODUCT_LOOKUP_DATA = 'fetch_product_lookup_data';
export const FETCH_PRODUCT = 'fetch_product';
export const FETCH_PRODUCT_SUCCESS = 'fetch_product_success';
export const FETCH_ALL_PRODUCT = 'fetch_all_product';
export const FETCH_ALL_PRODUCT_SUCCESS = 'fetch_all_product_success';
export const FILTER_PRODUCT = 'filter_product';
export const GET_ALL_PRODUCT = 'get_all_product';
export const GET_UNSELECTED_ALL_PRODUCT = 'get_unselected_all_product';
export const HANDLE_PRODUCT_REQUEST_CLOSE = 'handle_product_request_close';
export const HIDE_PRODUCT_LOADER = 'hide_product_loader';
export const SHOW_PRODUCT_LOADER = 'show_product_loader';
export const ON_ADD_PRODUCT = 'on_add_product';
export const ON_EDIT_PRODUCT = 'on_edit_product';
export const SET_PRODUCT = 'set_product';
export const ON_ALL_PRODUCT_SELECT = 'on_all_product_select';
export const ON_PRODUCT_CLOSE = 'on_product_close';
export const ON_PRODUCT_SELECT = 'on_product_select';
export const ON_DELETE_PRODUCT = 'on_delete_product';
export const ON_DELETE_PRODUCT_SUCCESS = 'on_delete_product_success';
export const ON_FILTER_SELECTED_PRODUCT = 'on_filter_selected_product';
export const ON_FILTER_PRODUCT_OPTION_SELECT = 'on_filter_product_option_select';
export const ON_SAVE_PRODUCT = 'on_save_product';
export const ON_SAVE_PRODUCT_SUCCESS = 'on_save_product_success';
export const ON_TOGGLE_PRODUCT_DRAWER = 'on_toggle_product_drawer';
export const SHOW_PRODUCT_MESSAGE = 'show_product_message';
export const UPDATE_SEARCH_PRODUCT = 'update_search_product';
export const ON_FETCH_SELECT_VALUESTREAM_DATA = 'on_fetch_select_valueStream_data';
export const ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS = 'on_fetch_select_valueStream_data_success';
export const ON_PRODUCT_VALUESTREAM_UPDATE = 'on_product_valueStream_update';

// team component actionTypes

export const ADD_FAVOURITE_TEAM = 'add_favourite_team';
export const ADD_FAVOURITE_TEAM_SUCCESS = 'add_favourite_team_success';
export const FETCH_TEAM = 'fetch_team';
export const FETCH_TEAM_SUCCESS = 'fetch_team_success';
export const FETCH_ALL_TEAM = 'fetch_all_team';
export const FETCH_ALL_TEAM_SUCCESS = 'fetch_all_team_success';
export const FILTER_TEAM = 'filter_team';
export const GET_ALL_TEAM = 'get_all_team';
export const GET_UNSELECTED_ALL_TEAM = 'get_unselected_all_team';
export const HANDLE_TEAM_REQUEST_CLOSE = 'handle_team_request_close';
export const HIDE_TEAM_LOADER = 'hide_team_loader';
export const SHOW_TEAM_LOADER = 'show_team_loader';
export const ON_ADD_TEAM = 'on_add_team';
export const ON_EDIT_TEAM = 'on_edit_team';
export const SET_TEAM = 'set_team';
export const ON_ALL_TEAM_SELECT = 'on_all_team_select';
export const ON_TEAM_CLOSE = 'on_team_close';
export const ON_TEAM_SELECT = 'on_team_select';
export const ON_DELETE_TEAM = 'on_delete_team';
export const ON_DELETE_TEAM_SUCCESS = 'on_delete_team_success';
export const ON_FILTER_SELECTED_TEAM = 'on_filter_selected_team';
export const ON_FILTER_TEAM_OPTION_SELECT = 'on_filter_team_option_select';
export const ON_SAVE_TEAM = 'on_save_team';
export const ON_SAVE_TEAM_SUCCESS = 'on_save_team_success';
export const ON_TOGGLE_TEAM_DRAWER = 'on_toggle_team_drawer';
export const SHOW_TEAM_MESSAGE = 'show_team_message';
export const UPDATE_SEARCH_TEAM = 'update_search_team';
export const ON_FETCH_SELECT_MEMBER_DATA = 'on_fetch_select_member_data';
export const ON_FETCH_SELECT_MEMBER_DATA_SUCCESS = 'on_fetch_select_member_data_success';
export const ON_TEAM_MEMBER_UPDATE = 'on_team_member_update';

// member component actionTypes

export const ADD_FAVOURITE_MEMBER = 'add_favourite_member';
export const ADD_FAVOURITE_MEMBER_SUCCESS = 'add_favourite_member_success';
export const FETCH_MEMBER = 'fetch_member';
export const FETCH_MEMBER_SUCCESS = 'fetch_member_success';
export const FETCH_ALL_MEMBER = 'fetch_all_member';
export const FETCH_ALL_MEMBER_SUCCESS = 'fetch_all_member_success';
export const FILTER_MEMBER = 'filter_member';
export const GET_ALL_MEMBER = 'get_all_member';
export const GET_UNSELECTED_ALL_MEMBER = 'get_unselected_all_member';
export const HANDLE_MEMBER_REQUEST_CLOSE = 'handle_member_request_close';
export const HIDE_MEMBER_LOADER = 'hide_member_loader';
export const SHOW_MEMBER_LOADER = 'show_member_loader';
export const ON_ADD_MEMBER = 'on_add_member';
export const ON_EDIT_MEMBER = 'on_edit_member';
export const ON_ALL_MEMBER_SELECT = 'on_all_member_select';
export const ON_MEMBER_CLOSE = 'on_member_close';
export const ON_MEMBER_SELECT = 'on_member_select';
export const ON_DELETE_MEMBER = 'on_delete_member';
export const ON_DELETE_MEMBER_SUCCESS = 'on_delete_member_success';
export const ON_FILTER_SELECTED_MEMBER = 'on_filter_selected_member';
export const ON_FILTER_MEMBER_OPTION_SELECT = 'on_filter_member_option_select';
export const ON_SAVE_MEMBER = 'on_save_member';
export const ON_SAVE_MEMBER_SUCCESS = 'on_save_member_success';
export const ON_TOGGLE_MEMBER_DRAWER = 'on_toggle_member_drawer';
export const SHOW_MEMBER_MESSAGE = 'show_member_message';
export const UPDATE_SEARCH_MEMBER = 'update_search_member';

// valueStream component actionTypes

export const ADD_FAVOURITE_VALUE_STREAM = 'add_favourite_value_stream';
export const ADD_FAVOURITE_VALUE_STREAM_SUCCESS = 'add_favourite_value_stream_success';
export const FETCH_VALUE_STREAM = 'fetch_value_stream';
export const FETCH_VALUE_STREAM_SUCCESS = 'fetch_value_stream_success';
export const FETCH_ALL_VALUE_STREAM = 'fetch_all_value_stream';
export const FETCH_ALL_VALUE_STREAM_SUCCESS = 'fetch_all_value_stream_success';
export const FILTER_VALUE_STREAM = 'filter_value_stream';
export const GET_ALL_VALUE_STREAM = 'get_all_value_stream';
export const GET_UNSELECTED_ALL_VALUE_STREAM = 'get_unselected_all_value_stream';
export const HANDLE_VALUE_STREAM_REQUEST_CLOSE = 'handle_value_stream_request_close';
export const HIDE_VALUE_STREAM_LOADER = 'hide_value_stream_loader';
export const SHOW_VALUE_STREAM_LOADER = 'show_value_stream_loader';
export const ON_ADD_VALUE_STREAM = 'on_add_value_stream';
export const ON_EDIT_VALUE_STREAM = 'on_edit_value_stream';
export const SET_VALUE_STREAM = 'set_value_stream';
export const ON_ALL_VALUE_STREAM_SELECT = 'on_all_value_stream_select';
export const ON_VALUE_STREAM_CLOSE = 'on_value_stream_close';
export const ON_VALUE_STREAM_SELECT = 'on_value_stream_select';
export const ON_DELETE_VALUE_STREAM = 'on_delete_value_stream';
export const ON_DELETE_VALUE_STREAM_SUCCESS = 'on_delete_value_stream_success';
export const ON_FILTER_SELECTED_VALUE_STREAM = 'on_filter_selected_value_stream';
export const ON_FILTER_VALUE_STREAM_OPTION_SELECT = 'on_filter_value_stream_option_select';
export const ON_SAVE_VALUE_STREAM = 'on_save_value_stream';
export const ON_SAVE_VALUE_STREAM_SUCCESS = 'on_save_value_stream_success';
export const ON_TOGGLE_VALUE_STREAM_DRAWER = 'on_toggle_value_stream_drawer';
export const SHOW_VALUE_STREAM_MESSAGE = 'show_value_stream_message';
export const UPDATE_SEARCH_VALUE_STREAM = 'update_search_value_stream';
export const ON_FETCH_SELECT_TEAM_DATA = 'on_fetch_select_team_data';
export const ON_FETCH_SELECT_TEAM_DATA_SUCCESS = 'on_fetch_select_team_data_success';
export const ON_VALUE_STREAM_TEAM_UPDATE = 'on_value_stream_team_update';
// feature component actionTypes
export const ADD_FAVOURITE_FEATURE = 'add_favourite_feature';
export const ADD_FAVOURITE_FEATURE_SUCCESS = 'add_favourite_feature_success';
export const FETCH_FEATURE = 'fetch_feature';
export const FETCH_FEATURE_SUCCESS = 'fetch_feature_success';
export const FETCH_ALL_FEATURE = 'fetch_all_feature';
export const FETCH_ALL_FEATURE_SUCCESS = 'fetch_all_feature_success';
export const FILTER_FEATURE = 'filter_feature';
export const GET_ALL_FEATURE = 'get_all_feature';
export const GET_UNSELECTED_ALL_FEATURE = 'get_unselected_all_feature';
export const HANDLE_FEATURE_REQUEST_CLOSE = 'handle_feature_request_close';
export const HIDE_FEATURE_LOADER = 'hide_feature_loader';
export const SHOW_FEATURE_LOADER = 'show_feature_loader';
export const ON_ADD_FEATURE = 'on_add_feature';
export const ON_EDIT_FEATURE = 'on_edit_feature';
export const ON_ALL_FEATURE_SELECT = 'on_all_feature_select';
export const ON_FEATURE_CLOSE = 'on_feature_close';
export const ON_FEATURE_SELECT = 'on_feature_select';
export const ON_DELETE_FEATURE = 'on_delete_feature';
export const ON_DELETE_FEATURE_SUCCESS = 'on_delete_feature_success';
export const ON_FILTER_SELECTED_FEATURE = 'on_filter_selected_feature';
export const ON_FILTER_FEATURE_OPTION_SELECT = 'on_filter_feature_option_select';
export const ON_SAVE_FEATURE = 'on_save_feature';
export const ON_SAVE_FEATURE_SUCCESS = 'on_save_feature_success';
export const ON_TOGGLE_FEATURE_DRAWER = 'on_toggle_feature_drawer';
export const SHOW_FEATURE_MESSAGE = 'show_feature_message';
export const UPDATE_SEARCH_FEATURE = 'update_search_feature';
export const SET_FEATURE = 'set_feature';
export const ON_FEATURE_INWARD_DEPENDENCY_UPDATE = 'on_feature_inward_dependency_update';
export const ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE = 'on_feature_outward_dependency_update';
export const ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS = 'on_feature_dependency_update_success';
export const ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES = 'on_fetch_select_feature_inward_dependencies';
export const ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES = 'on_fetch_select_feature_outward_dependencies';
export const ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS = 'on_fetch_select_feature_dependencies_success';

// portfolio component actiontypes

export const SELECT_PORTFOLIO = 'select_portfolio';
export const ON_PORTFOLIO_DASHBOARD = 'on_portfolio_dashboard';
export const ON_PORTFOLIO_DASHBOARD_SUCCESS = 'on_portfolio_dashboard_success';
export const ADD_FAVOURITE_PORTFOLIO = 'add_favourite_portfolios';
export const ADD_FAVOURITE_PORTFOLIO_SUCCESS = 'add_favourite_portfolios_success';
export const FETCH_PORTFOLIO = 'fetch_portfolios';
export const FETCH_PORTFOLIO_SUCCESS = 'fetch_portfolios_success';
export const FETCH_ALL_PORTFOLIO = 'fetch_all_portfolios';
export const FETCH_ALL_PORTFOLIO_SUCCESS = 'fetch_all_portfolios_success';
export const FILTER_PORTFOLIO = 'filter_portfolios';
export const GET_ALL_PORTFOLIO = 'get_all_portfolios';
export const GET_UNSELECTED_ALL_PORTFOLIO = 'get_unselected_all_portfolios';
export const HANDLE_PORTFOLIO_REQUEST_CLOSE = 'handle_portfolios_request_close';
export const HIDE_PORTFOLIO_LOADER = 'hide_portfolios_loader';
export const SHOW_PORTFOLIO_LOADER = 'show_portfolios_loader';
export const ON_ADD_PORTFOLIO = 'on_add_portfolios';
export const ON_EDIT_PORTFOLIO = 'on_edit_portfolios';
export const ON_ALL_PORTFOLIO_SELECT = 'on_all_portfolios_select';
export const ON_PORTFOLIO_CLOSE = 'on_portfolios_close';
export const ON_PORTFOLIO_SELECT = 'on_portfolios_select';
export const ON_DELETE_PORTFOLIO = 'on_delete_portfolios';
export const ON_DELETE_PORTFOLIO_SUCCESS = 'on_delete_portfolios_success';
export const ON_FILTER_SELECTED_PORTFOLIO = 'on_filter_selected_portfolios';
export const ON_FILTER_PORTFOLIO_OPTION_SELECT = 'on_filter_portfolios_option_select';
export const ON_SAVE_PORTFOLIO = 'on_save_portfolios';
export const ON_SAVE_PORTFOLIO_SUCCESS = 'on_save_portfolios_success';
export const ON_TOGGLE_PORTFOLIO_DRAWER = 'on_toggle_portfolios_drawer';
export const SHOW_PORTFOLIO_MESSAGE = 'show_portfolios_message';
export const UPDATE_SEARCH_PORTFOLIO = 'update_search_portfolios';

// businessUnit component actionTypes

export const ADD_FAVOURITE_BUSINESS_UNIT = 'add_favourite_business_unit';
export const ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS = 'add_favourite_business_unit_success';
export const FETCH_BUSINESS_UNIT = 'fetch_business_unit';
export const FETCH_BUSINESS_UNIT_SUCCESS = 'fetch_business_unit_success';
export const FETCH_ALL_BUSINESS_UNIT = 'fetch_all_business_unit';
export const FETCH_ALL_BUSINESS_UNIT_SUCCESS = 'fetch_all_business_unit_success';
export const FILTER_BUSINESS_UNIT = 'filter_business_unit';
export const GET_ALL_BUSINESS_UNIT = 'get_all_business_unit';
export const GET_UNSELECTED_ALL_BUSINESS_UNIT = 'get_unselected_all_business_unit';
export const HANDLE_BUSINESS_UNIT_REQUEST_CLOSE = 'handle_business_unit_request_close';
export const HIDE_BUSINESS_UNIT_LOADER = 'hide_business_unit_loader';
export const SHOW_BUSINESS_UNIT_LOADER = 'show_business_unit_loader';
export const ON_ADD_BUSINESS_UNIT = 'on_add_business_unit';
export const ON_ALL_BUSINESS_UNIT_SELECT = 'on_all_business_unit_select';
export const ON_BUSINESS_UNIT_CLOSE = 'on_business_unit_close';
export const ON_BUSINESS_UNIT_SELECT = 'on_business_unit_select';
export const ON_DELETE_BUSINESS_UNIT = 'on_delete_business_unit';
export const ON_DELETE_BUSINESS_UNIT_SUCCESS = 'on_delete_business_unit_success';
export const ON_FILTER_SELECTED_BUSINESS_UNIT = 'on_filter_selected_business_unit';
export const ON_FILTER_BUSINESS_UNIT_OPTION_SELECT = 'on_filter_business_unit_option_select';
export const ON_SAVE_BUSINESS_UNIT = 'on_save_business_unit';
export const ON_SAVE_BUSINESS_UNIT_SUCCESS = 'on_save_business_unit_success';
export const ON_TOGGLE_BUSINESS_UNIT_DRAWER = 'on_toggle_business_unit_drawer';
export const SHOW_BUSINESS_UNIT_MESSAGE = 'show_business_unit_message';
export const UPDATE_SEARCH_BUSINESS_UNIT = 'update_search_business_unit';

// projectIssue component actionTypes

export const ADD_FAVOURITE_PROJECT_ISSUE = 'add_favourite_project_issue';
export const ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS = 'add_favourite_project_issue_success';
export const FETCH_PROJECT_ISSUE = 'fetch_project_issue';
export const FETCH_PROJECT_ISSUE_SUCCESS = 'fetch_project_issue_success';
export const FETCH_ALL_PROJECT_ISSUE = 'fetch_all_project_issue';
export const FETCH_ALL_PROJECT_ISSUE_SUCCESS = 'fetch_all_project_issue_success';
export const FILTER_PROJECT_ISSUE = 'filter_project_issue';
export const GET_ALL_PROJECT_ISSUE = 'get_all_project_issue';
export const GET_UNSELECTED_ALL_PROJECT_ISSUE = 'get_unselected_all_project_issue';
export const HANDLE_PROJECT_ISSUE_REQUEST_CLOSE = 'handle_project_issue_request_close';
export const HIDE_PROJECT_ISSUE_LOADER = 'hide_project_issue_loader';
export const SHOW_PROJECT_ISSUE_LOADER = 'show_project_issue_loader';
export const ON_ADD_PROJECT_ISSUE = 'on_add_project_issue';
export const ON_ADD_JIRA_PROJECT_ISSUE = 'on_add_jira_project_issue';
export const ON_ALL_PROJECT_ISSUE_SELECT = 'on_all_project_issue_select';
export const ON_PROJECT_ISSUE_CLOSE = 'on_project_issue_close';
export const ON_PROJECT_ISSUE_SELECT = 'on_project_issue_select';
export const ON_DELETE_PROJECT_ISSUE = 'on_delete_project_issue';
export const ON_DELETE_PROJECT_ISSUE_SUCCESS = 'on_delete_project_issue_success';
export const ON_FILTER_SELECTED_PROJECT_ISSUE = 'on_filter_selected_project_issue';
export const ON_FILTER_PROJECT_ISSUE_OPTION_SELECT = 'on_filter_project_issue_option_select';
export const ON_SAVE_PROJECT_ISSUE = 'on_save_project_issue';
export const ON_SAVE_JIRA_PROJECT_ISSUE = 'on_save_jira_project_issue';
export const ON_SAVE_PROJECT_ISSUE_SUCCESS = 'on_save_project_issue_success';
export const ON_TOGGLE_PROJECT_ISSUE_DRAWER = 'on_toggle_project_issue_drawer';
export const SHOW_PROJECT_ISSUE_MESSAGE = 'show_project_issue_message';
export const UPDATE_SEARCH_PROJECT_ISSUE = 'update_search_project_issue';

// project priorities

export const ADD_FAVOURITE_PROJECT_PRIORITY = 'add_favourite_project_priority';
export const FETCH_PROJECT_PRIORITY = 'fetch_project_priority';
export const FETCH_PROJECT_PRIORITY_SUCCESS = 'fetch_project_priority_success';
export const FETCH_ALL_PROJECT_PRIORITY = 'fetch_all_project_priority';
export const FETCH_ALL_PROJECT_PRIORITY_SUCCESS = 'fetch_all_project_priority_success';
export const FILTER_PROJECT_PRIORITY = 'filter_project_priority';
export const GET_ALL_PROJECT_PRIORITY = 'get_all_project_priority';
export const GET_UNSELECTED_ALL_PROJECT_PRIORITY = 'get_unselected_all_project_priority';
export const HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE = 'handle_project_priority_request_close';
export const HIDE_PROJECT_PRIORITY_LOADER = 'hide_project_priority_loader';
export const SHOW_PROJECT_PRIORITY_LOADER = 'show_project_priority_loader';
export const ON_ADD_PROJECT_PRIORITY = 'on_add_project_priority';
export const ON_ALL_PROJECT_PRIORITY_SELECT = 'on_all_project_priority_select';
export const ON_PROJECT_PRIORITY_CLOSE = 'on_project_priority_close';
export const ON_PROJECT_PRIORITY_SELECT = 'on_project_priority_select';
export const ON_DELETE_PROJECT_PRIORITY = 'on_delete_project_priority';
export const ON_DELETE_PROJECT_PRIORITY_SUCCESS = 'on_delete_project_priority_success';
export const ON_DELETE_SELECTED_PROJECT_PRIORITY = 'on_delete_selected_project_priority';
export const ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT = 'on_filter_project_priority_option_select';
export const ON_SAVE_PROJECT_PRIORITY = 'on_save_project_priority';
export const ON_SAVE_PROJECT_PRIORITY_SUCCESS = 'on_save_project_priority_success';
export const ON_TOGGLE_PROJECT_PRIORITY_DRAWER = 'on_toggle_project_priority_drawer';
export const SHOW_PROJECT_PRIORITY_MESSAGE = 'show_project_priority_message';
export const UPDATE_SEARCH_PROJECT_PRIORITY = 'update_search_project_priority';

// projects

export const ADD_FAVOURITE_PROJECT = 'add_favourite_project';
export const ADD_FAVOURITE_PROJECT_SUCCESS = 'add_favourite_project_success';
export const FETCH_PROJECT = 'fetch_project';
export const FETCH_PROJECT_SUCCESS = 'fetch_project_success';
export const FETCH_ALL_PROJECT = 'fetch_all_project';
export const FETCH_ALL_PROJECT_SUCCESS = 'fetch_all_project_success';
export const FILTER_PROJECT = 'filter_project';
export const GET_ALL_PROJECT = 'get_all_project';
export const GET_UNSELECTED_ALL_PROJECT = 'get_unselected_all_project';
export const HANDLE_PROJECT_REQUEST_CLOSE = 'handle_project_request_close';
export const HIDE_PROJECT_LOADER = 'hide_project_loader';
export const SHOW_PROJECT_LOADER = 'show_project_loader';
export const ON_ADD_PROJECT = 'on_add_project';
export const ON_EDIT_PROJECT = 'on_edit_project';
export const ON_ALL_PROJECT_SELECT = 'on_all_project_select';
export const ON_PROJECT_CLOSE = 'on_project_close';
export const ON_PROJECT_SELECT = 'on_project_select';
export const ON_DELETE_PROJECT = 'on_delete_project';
export const ON_DELETE_PROJECT_SUCCESS = 'on_delete_project_success';
export const ON_DELETE_SELECTED_PROJECT = 'on_delete_selected_project';
export const ON_FILTER_PROJECT_OPTION_SELECT = 'on_filter_project_option_select';
export const ON_SAVE_PROJECT = 'on_save_project';
export const ON_UPDATE_PROJECT_PRIORITIES = 'on_update_project_priorities';
export const ON_SAVE_PROJECT_SUCCESS = 'on_save_project_success';
export const ON_TOGGLE_PROJECT_DRAWER = 'on_toggle_project_drawer';
export const SHOW_PROJECT_MESSAGE = 'show_project_message';
export const UPDATE_SEARCH_PROJECT = 'update_search_project';
export const ON_PROJECT_COST_PRIORITIES_DASHBOARD = 'on_project_cost_priorities_dashboard';
export const ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD = 'on_global_project_cost_priorities_dashboard';
export const ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = 'on_global_project_business_priorities_dashboard';
export const ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = 'on_project_business_priorities_dashboard';
export const FETCH_IMPORT_PROJECTS = 'fetch_import_projects';
export const FETCH_IMPORT_PROJECTS_SUCCESS = 'fetch_import_projects_success';
export const SHOW_IMPORT_PROJECTS_LOADER = 'show_import_projects_loader';
export const HIDE_IMPORT_PROJECTS_LOADER = 'hide_import_projects_loader';
export const ON_IMPORT_PROJECTS = 'on_import_projects';
export const ON_IMPORT_PROJECTS_SUCCESS = 'on_import_projects_success';
export const ON_PROJECT_ISSUES_DASHBOARD = 'on_project_issues_dashboard';
export const ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS = 'on_save_project_issues_cache_success';
export const ON_SAVE_PROJECT_CACHE_SUCCESS = 'on_save_project_cache_success';
export const SET_PROJECT_ISSUE = 'set_project_issue';
export const SET_PROJECT = 'set_project';


// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const WINDOW_HEIGHT = 'window-height';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

export const COLOR_OPTIONS_MODAL = 'color_options_modal';
export const USER_INFO_MODAL = 'user_info_modal';

// clear session data

export const CLEAR_SESSION = 'session.clear';
export const CLEAR_SELECTED_OBJECTS = 'clear.selected.objects';

//Contact Module const

export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';

export const ON_TOGGLE_DRAWER = 'on_toggle_drawer';
export const HANDLE_REQUEST_CLOSE = 'handle_request_close';
export const ADD_FAVOURITE = 'add_favourite';

export const FETCH_ALL_CONTACT = 'fetch_all_contact';
export const FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
export const ON_CONTACT_SELECT = 'on_contact_select';
export const ON_ADD_CONTACT = 'on_add_contact';
export const ON_CONTACT_CLOSE = 'on_contact_close';
export const ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
export const ON_SAVE_CONTACT = 'on_save_contact';
export const ON_DELETE_CONTACT = 'on_delete_contact';
export const ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
export const FILTER_CONTACT = 'filter_contact';
export const GET_ALL_CONTACT = 'get_all_contact';
export const GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
export const ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
export const UPDATE_SEARCH_USER = 'update_search_user';
export const HIDE_CONTACT_LOADER = 'hide_contact_loader';

//Auth const
export const SIGNUP_USER = 'signup_user';
export const SIGNUP_USER_SUCCESS = 'signup_user_success';
export const SIGNIN_GOOGLE_USER = 'signin_google_user';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
export const SIGNIN_FACEBOOK_USER = 'signin_facebook_user';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
export const SIGNIN_TWITTER_USER = 'signin_twitter_user';
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
export const SIGNIN_GITHUB_USER = 'signin_github_user';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_PASSWORDLESS = 'signin_user_passwordless';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const IDENTITY_SUCCESS = 'identity_success';
export const REQUEST_SIGNIN_ACCESS_CODE = 'request_signin_user_code';
export const REQUEST_SIGNIN_ACCESS_CODE_SUCCESS = 'request_signin_user_code_success';

// Chat Module const

export const FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
export const FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
export const FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
export const FILTER_USERS = 'filter_users';
export const ON_SELECT_USER = 'on_select_user';
export const USER_INFO_STATE = 'user_info_state';
export const SUBMIT_COMMENT = 'submit_comment';
export const UPDATE_MESSAGE_VALUE = 'update_message_value';
export const UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';

//// Mail Module const


export const ADD_LABEL = 'ADD_LABEL';
export const GET_ALL_MAIL = 'get_all_mail';
export const FETCH_ALL_MAIL = 'fetch_all_mail';
export const FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
export const GET_IMPORTANT_MAIL = 'get_important_mail';
export const GET_NAV_FILTERS = 'get_nav_filters';
export const GET_NAV_LABELS = 'get_nav_labels';
export const GET_NAV_FOLDER = 'get_nav_folder';
export const GET_READ_MAIL = 'get_read_mail';
export const GET_STARRED_MAIL = 'get_starred_mail';
export const GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
export const GET_UNREAD_MAIL = 'get_unread_mail';
export const GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
export const GET_UNSTARRED_MAIL = 'get_unstarred_mail';
export const ON_ALL_MAIL_SELECT = 'on_all_mail_select';
export const ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
export const ON_FOLDER_SELECT = 'on_folder_select';
export const ON_IMPORTANT_SELECT = 'on_important_select';
export const ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
export const GET_MARK_AS_START = 'get_mark_as_start';
export const ON_LABEL_SELECT = 'on_label_select';
export const ON_MAIL_CHECKED = 'on_mail_checked';
export const ON_MAIL_SELECT = 'on_mail_select';
export const ON_MAIL_SEND = 'on_mail_send';
export const ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
export const ON_OPTION_MENU_SELECT = 'on_option_menu_select';
export const ON_START_SELECT = 'on_start_select';
export const SEARCH_MAIL = 'search_mail';
export const ON_DELETE_MAIL = 'on_delete_mail';
export const SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
export const ON_COMPOSE_MAIL = 'on_compose_mail';

//// TO-DO Module const

export const ON_SORTEND = 'on_sortend';
export const FETCH_ALL_TODO = 'fetch_all_todo';
export const FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
export const FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
export const SELECT_ALL_TODO = 'select_all_todo';
export const GET_ALL_TODO = 'get_all_todo';
export const GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
export const GET_STARRED_TODO = 'get_starred_todo';
export const GET_UNSTARRED_TODO = 'get_unstarred_todo';
export const GET_IMPORTANT_TODO = 'get_important_todo';
export const GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
export const ON_LABEL_UPDATE = 'on_label_update';
export const ON_TODO_UPDATE = 'on_todo_update';
export const ON_DELETE_TODO = 'on_delete_todo';
export const SEARCH_TODO = 'search_todo';
export const SHOW_TODOS = 'show_todos';
export const GET_TODO_CONVERSATION = 'get_todo_conversation';
export const ON_TODO_CHECKED = 'on_todo_checked';
export const ON_TODO_ADD = 'on_todo_add';
export const ON_TODO_SELECT = 'on_todo_select';
export const SET_CURRENT_TODO_NULL = 'set_current_todo_null';
export const REMOVE_LABEL = 'remove_label';
export const UPDATE_SEARCH = 'update_search';

// organisations

export const SHOW_ORG_MESSAGE = 'show_org_message';
export const ON_TOGGLE_ORG_DRAWER = 'toggle_org_drawer';
export const HANDLE_ORG_REQUEST_CLOSE = 'handle_org_request_close';
export const ON_FILTER_ORG_OPTION_SELECT = 'on_filter_org_option_select';
export const HIDE_ORG_LOADER = 'hide_org_loader';
export const SHOW_ORG_LOADER = 'show_org_loader';
export const ADD_FAVOURITE_ORG = 'add_favourite_org';
export const FETCH_ORG = 'fetch_org';
export const FETCH_ORG_SUCCESS = 'fetch_org_success';
export const FETCH_ORGS_SELECT_ORG = 'fetch_org_select_org';
export const FETCH_ALL_ORG = 'fetch_all_org';
export const FETCH_ALL_ORG_SUCCESS = 'fetch_all_org_success';
export const ON_ORG_SELECT = 'on_org_select';
export const ON_ADD_ORG = 'on_add_org';
export const ON_ORG_CLOSE = 'on_org_close';
export const ON_SAVE_ORG = 'on_save_org';
export const ON_SAVE_ORG_SUCCESS = 'on_save_org_success';
export const ON_DELETE_ORG = 'on_delete_org';
export const ON_DELETE_SELECTED_ORG = 'on_delete_selected_org';
export const FILTER_ORG = 'filter_org';
export const GET_ALL_ORG = 'get_all_org';
export const GET_UNSELECTED_ALL_ORG = 'get_unselected_all_org';
export const ON_ALL_ORG_SELECT = 'on_all_org_select';
export const UPDATE_SEARCH_ORG = 'update_search_org';
export const ON_EMP_DASHBOARD = 'on_emp_dashboard';
export const ON_ORG_SURVEY_DASHBOARD = 'on_org_survey_dashbaord';
export const ON_ORG_DASHBOARD = 'on_org_dashbaord';
export const ON_ORG_DASHBOARD_SUCCESS = 'on_org_dashbaord_success';
export const ON_PROJECT_DASHBOARD = 'on_project_dashboard';
export const ON_IMPERSONATE_DASHBOARD = 'on_impersonate_dashboard';
export const ON_PROJECT_PRIORITY_DASHBOARD = 'on_project_priority_dashboard';
export const FETCH_ORG_STATISTICS = 'fetch_org_statistics';
export const FETCH_ORG_STATISTICS_SUCCESS = 'fetch_org_statistics_success';

// employees
export const SHOW_EMP_MESSAGE = 'show_emp_message';
export const ON_TOGGLE_EMP_DRAWER = 'toggle_emp_drawer';
export const HANDLE_EMP_REQUEST_CLOSE = 'handle_emp_request_close';
export const ON_FILTER_EMP_OPTION_SELECT = 'on_filter_emp_option_select';
export const HIDE_EMP_LOADER = 'hide_emp_loader';
export const SHOW_EMP_DASHBOARD_LOADER = 'show_emp_dashboard_loader';
export const HIDE_EMP_DASHBOARD_LOADER = 'hide_emp_dashboard_loader';
export const SHOW_EMP_LOADER = 'show_emp_loader';
export const ADD_FAVOURITE_EMP = 'add_favourite_emp';
export const ADD_FAVOURITE_EMP_SUCCESS = 'add_favourite_emp_success';
export const FETCH_ALL_EMP = 'fetch_all_emp';
export const FETCH_ALL_EMP_SUCCESS = 'fetch_all_emp_success';
export const ON_EMP_SELECT = 'on_emp_select';
export const ON_ADD_EMP = 'on_add_emp';
export const ON_EMP_CLOSE = 'on_emp_close';
export const ON_SAVE_EMP = 'on_save_emp';
export const ON_SAVE_EMP_SUCCESS = 'on_save_emp_success';
export const ON_DELETE_EMP = 'on_delete_emp';
export const ON_DELETE_SELECTED_EMP = 'on_delete_selected_emp';
export const FILTER_EMP = 'filter_emp';
export const GET_ALL_EMP = 'get_all_emp';
export const GET_UNSELECTED_ALL_EMP = 'get_unselected_all_emp';
export const ON_ALL_EMP_SELECT = 'on_all_emp_select';
export const UPDATE_SEARCH_EMP = 'update_search_emp';
export const FETCH_EMP_SURVEY_ANSWERS = 'fetch_emp_survey_answers';
export const FETCH_EMP_SURVEY_ANSWERS_SUCCESS = 'fetch_emp_survey_answers_success';
export const SAVE_EMP_SURVEY_ANSWERS = 'save_emp_survey_answers';
export const SAVE_EMP_SURVEY_ANSWERS_SUCCESS = 'save_emp_survey_answers_success';
export const FETCH_NOTIFICATIONS = 'fetch_notifications';
export const FETCH_NOTIFICATIONS_SUCCESS = 'fetch_notifications_success';

// org surveys
export const SHOW_ORG_SURVEY_MESSAGE = 'show_org_survey_message';
export const ON_TOGGLE_ORG_SURVEY_DRAWER = 'toggle_org_survey_drawer';
export const HANDLE_ORG_SURVEY_REQUEST_CLOSE = 'handle_org_survey_request_close';
export const ON_FILTER_ORG_SURVEY_OPTION_SELECT = 'on_filter_org_survey_option_select';
export const HIDE_ORG_SURVEY_LOADER = 'hide_org_survey_loader';
export const SHOW_ORG_SURVEY_LOADER = 'show_org_survey_loader';
export const ADD_FAVOURITE_ORG_SURVEY = 'add_favourite_org_survey';
export const FETCH_ALL_ORG_SURVEY = 'fetch_all_org_survey';
export const FETCH_ALL_ORG_SURVEY_SUCCESS = 'fetch_all_org_survey_success';
export const ON_ORG_SURVEY_SELECT = 'on_org_survey_select';
export const ON_ADD_ORG_SURVEY = 'on_add_org_survey';
export const ON_ORG_SURVEY_CLOSE = 'on_org_survey_close';
export const ON_SAVE_ORG_SURVEY = 'on_save_org_survey';
export const ON_SAVE_ORG_SURVEY_SUCCESS = 'on_save_org_survey_success';
export const ON_DELETE_ORG_SURVEY = 'on_delete_org_survey';
export const ON_DELETE_SELECTED_ORG_SURVEY = 'on_delete_selected_org_survey';
export const FILTER_ORG_SURVEY = 'filter_org_survey';
export const GET_ALL_ORG_SURVEY = 'get_all_org_survey';
export const GET_UNSELECTED_ALL_ORG_SURVEY = 'get_unselected_all_org_survey';
export const ON_ALL_ORG_SURVEY_SELECT = 'on_all_org_survey_select';
export const UPDATE_SEARCH_ORG_SURVEY = 'update_search_org_survey';
export const ON_ORG_SURVEY_QUESTIONS = 'on_org_survey_questions';
export const ON_ORG_SURVEY_COMPARE_DASHBOARD = 'on_org_survey_compare_dashbaord';
export const ON_ORG_SURVEY_COMPARE_SELECT = 'on_org_survey_compare_select';
export const FETCH_ALL_ORG_SURVEY_COMPARE = 'fetch_all_org_survey_compare';
export const FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS = 'fetch_all_org_survey_compare_success';
export const FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA = 'fetch_all_org_survey_compare_radar_chart_data';
export const FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_radar_chart_data_success';
export const FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA = 'fetch_all_org_survey_compare_distributions_chart_data';
export const FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_distributions_chart_data_success';
export const FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA = 'fetch_all_org_survey_compare_top_results_chart_data';
export const FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_top_results_chart_data_success';
export const FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA = 'fetch_all_org_survey_compare_bottom_results_chart_data';
export const FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_bottom_results_chart_data_success';
export const FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA = 'fetch_all_org_survey_engagement_report_chart_data';
export const FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS = 'fetch_all_org_survey_engagement_report_chart_data_success';

// org survey answers
export const ON_SAVE_ORG_SURVEY_ANSWERS = 'on_save_org_survey_answers';
export const ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS = 'on_save_org_survey_answers_success';
export const FETCH_ORG_SURVEY_ANSWERS = 'fetch_org_survey_answers';
export const FETCH_ORG_SURVEY_ANSWERS_SUCCESS = 'fetch_org_survey_answers_success';
export const HIDE_ORG_SURVEY_ANSWERS_LOADER = 'hide_org_survey_answers_loader';
export const SHOW_ORG_SURVEY_ANSWERS_LOADER = 'show_org_survey_answers_loader';
export const SHOW_ORG_SURVEY_ANSWERS_MESSAGE = 'show_org_survey_answers_message';
export const HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE = 'handle_org_survey_answer_message_close';

// surveys
export const SHOW_SURVEY_MESSAGE = 'show_survey_message';
export const ON_TOGGLE_SURVEY_DRAWER = 'toggle_survey_drawer';
export const HANDLE_SURVEY_REQUEST_CLOSE = 'handle_survey_request_close';
export const ON_FILTER_SURVEY_OPTION_SELECT = 'on_filter_survey_option_select';
export const HIDE_SURVEY_LOADER = 'hide_survey_loader';
export const SHOW_SURVEY_LOADER = 'show_survey_loader';
export const ADD_FAVOURITE_SURVEY = 'add_favourite_survey';
export const FETCH_ALL_SURVEY = 'fetch_all_survey';
export const FETCH_ALL_SURVEY_SUCCESS = 'fetch_all_survey_success';
export const ON_SURVEY_SELECT = 'on_survey_select';
export const ON_ADD_SURVEY = 'on_add_survey';
export const ON_SURVEY_CLOSE = 'on_survey_close';
export const ON_SAVE_SURVEY = 'on_save_survey';
export const ON_SAVE_SURVEY_SUCCESS = 'on_save_survey_success';
export const ON_DELETE_SURVEY = 'on_delete_survey';
export const ON_DELETE_SELECTED_SURVEY = 'on_delete_selected_survey';
export const FILTER_SURVEY = 'filter_survey';
export const GET_ALL_SURVEY = 'get_all_survey';
export const GET_UNSELECTED_ALL_SURVEY = 'get_unselected_all_survey';
export const ON_ALL_SURVEY_SELECT = 'on_all_survey_select';
export const UPDATE_SEARCH_SURVEY = 'update_search_survey';
export const ON_SURVEY_QUESTIONS = 'on_survey_questions';

// survey groups
export const SHOW_SURVEY_GROUP_MESSAGE = 'show_survey_group_message';
export const ON_TOGGLE_SURVEY_GROUP_DRAWER = 'toggle_survey_group_drawer';
export const HANDLE_SURVEY_GROUP_REQUEST_CLOSE = 'handle_survey_group_request_close';
export const ON_FILTER_SURVEY_GROUP_OPTION_SELECT = 'on_filter_survey_group_option_select';
export const HIDE_SURVEY_GROUP_LOADER = 'hide_survey_group_loader';
export const SHOW_SURVEY_GROUP_LOADER = 'show_survey_group_loader';
export const ADD_FAVOURITE_SURVEY_GROUP = 'add_favourite_survey_group';
export const FETCH_ALL_SURVEY_GROUP = 'fetch_all_survey_group';
export const FETCH_ALL_SURVEY_GROUP_SUCCESS = 'fetch_all_survey_group_success';
export const ON_SURVEY_GROUP_SELECT = 'on_survey_group_select';
export const ON_ADD_SURVEY_GROUP = 'on_add_survey_group';
export const ON_SURVEY_GROUP_CLOSE = 'on_survey_group_close';
export const ON_SAVE_SURVEY_GROUP = 'on_save_survey_group';
export const ON_SAVE_SURVEY_GROUP_SUCCESS = 'on_save_survey_group_success';
export const ON_DELETE_SURVEY_GROUP = 'on_delete_survey_group';
export const ON_DELETE_SELECTED_SURVEY_GROUP = 'on_delete_selected_survey_group';
export const FILTER_SURVEY_GROUP = 'filter_survey_group';
export const GET_ALL_SURVEY_GROUP = 'get_all_survey_group';
export const GET_UNSELECTED_ALL_SURVEY_GROUP = 'get_unselected_all_survey_group';
export const ON_ALL_SURVEY_GROUP_SELECT = 'on_all_survey_group_select';
export const UPDATE_SEARCH_SURVEY_GROUP = 'update_search_survey_group';
export const ON_SURVEY_GROUP_QUESTIONS = 'on_survey_group_questions';

// survey questions
export const SHOW_SURVEY_QUESTION_MESSAGE = 'show_survey_question_message';
export const FETCH_ALL_SURVEY_QUESTION_SUCCESS = 'fetch_all_survey_question_success';
export const FETCH_ALL_SURVEY_QUESTION = 'fetch_all_survey_question';
export const HIDE_SURVEY_QUESTION_LOADER = 'hide_survey_question_loader';
export const SHOW_SURVEY_QUESTION_LOADER = 'show_survey_question_loader';

// survey group QUESTIONS
export const SHOW_SURVEY_GROUP_QUESTION_MESSAGE = 'show_survey_group_question_message';
export const ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER = 'toggle_survey_group_question_drawer';
export const HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE = 'handle_survey_group_question_request_close';
export const ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT = 'on_filter_survey_group_question_option_select';
export const HIDE_SURVEY_GROUP_QUESTION_LOADER = 'hide_survey_group_question_loader';
export const SHOW_SURVEY_GROUP_QUESTION_LOADER = 'show_survey_group_question_loader';
export const ADD_FAVOURITE_SURVEY_GROUP_QUESTION = 'add_favourite_survey_group';
export const FETCH_ALL_SURVEY_GROUP_QUESTION = 'fetch_all_survey_group';
export const FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS = 'fetch_all_survey_group_question_success';
export const ON_SURVEY_GROUP_QUESTION_SELECT = 'on_survey_group_question_select';
export const ON_ADD_SURVEY_GROUP_QUESTION = 'on_add_survey_group_question';
export const ON_SURVEY_GROUP_QUESTION_CLOSE = 'on_survey_group_question_close';
export const ON_SAVE_SURVEY_GROUP_QUESTION = 'on_save_survey_group_question';
export const ON_DELETE_SURVEY_GROUP_QUESTION = 'on_delete_survey_group';
export const ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION = 'on_delete_selected_survey_group';
export const FILTER_SURVEY_GROUP_QUESTION = 'filter_survey_group';
export const GET_ALL_SURVEY_GROUP_QUESTION = 'get_all_survey_group';
export const GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION = 'get_unselected_all_survey_group';
export const ON_ALL_SURVEY_GROUP_QUESTION_SELECT = 'on_all_survey_group_question_select';
export const UPDATE_SEARCH_SURVEY_GROUP_QUESTION = 'update_search_survey_group';

// security

export const ADD_FAVOURITE_SECURITY = 'add_favourite_security';
export const ADD_FAVOURITE_SECURITY_SUCCESS = 'add_favourite_security_success';
export const FETCH_SECURITY = 'fetch_security';
export const FETCH_SECURITY_SUCCESS = 'fetch_security_success';
export const FETCH_ALL_SECURITY = 'fetch_all_security';
export const FETCH_ALL_SECURITY_SUCCESS = 'fetch_all_security_success';
export const FILTER_SECURITY = 'filter_security';
export const GET_ALL_SECURITY = 'get_all_security';
export const GET_UNSELECTED_ALL_SECURITY = 'get_unselected_all_security';
export const HANDLE_SECURITY_REQUEST_CLOSE = 'handle_security_request_close';
export const HIDE_SECURITY_LOADER = 'hide_security_loader';
export const SHOW_SECURITY_LOADER = 'show_security_loader';
export const ON_ADD_SECURITY = 'on_add_security';
export const ON_ALL_SECURITY_SELECT = 'on_all_security_select';
export const ON_SECURITY_CLOSE = 'on_security_close';
export const ON_SECURITY_SELECT = 'on_security_select';
export const ON_DELETE_SECURITY = 'on_delete_security';
export const ON_DELETE_SECURITY_SUCCESS = 'on_delete_security_success';
export const ON_FILTER_SELECTED_SECURITY = 'on_filter_selected_security';
export const ON_FILTER_SECURITY_OPTION_SELECT = 'on_filter_security_option_select';
export const ON_SAVE_SECURITY = 'on_save_security';
export const ON_SAVE_SECURITY_SUCCESS = 'on_save_security_success';
export const ON_TOGGLE_SECURITY_DRAWER = 'on_toggle_security_drawer';
export const SHOW_SECURITY_MESSAGE = 'show_security_message';
export const UPDATE_SEARCH_SECURITY = 'update_search_security';


// WEBPACK FOOTER //
// ./constants/ActionTypes.js